<template>
  <div class="prenumerate">
    <div :class="[!getProductNumberOptions ? 'disabled' : '']" class="bundleOption row mt20 mb20">
      <span class="col-xs-12 col-md-6 flex middle-xs h5">{{ $t('Select the starting release') }}</span>
      <subscription-select class="col-xs-12 col-md-6 select" @change="setBundleOption" v-model="form.start" :options="getProductNumberOptions ? getProductNumberOptions : []" :selected="getProductNumberOptions ? getProductNumberOptions[0].value : ''" />
    </div>
  </div>
</template>

<script>
import SubscriptionSelect from 'theme/components/core/blocks/Form/SubscriptionSelect'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    SubscriptionSelect
  },
  props: {
    productOption: {
      type: Object,
      required: true
    },
    optionId: {
      type: Number,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        start: null
      },
      additionalOption: {}
    }
  },
  mounted () {
    this.$bus.$on('product-after-bundleoptions', this.setBundleOption)
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    getProductNumberOptions () {
      return this.productOption[this.optionId].sku ? this.$store.getters['subscription-product/getProductNumberOptions'](this.productOption[this.optionId].sku) : null
    }
  },
  methods: {
    setBundleOption (value) {
      if (typeof value === 'string') {
        this.additionalOption = {
          'number': value,
          'product_id': this.productOption[this.optionId].product_id
        }
      }
      if (!Object.keys(this.additionalOption).length) return
      let startingNumbers = this.product.product_option.extension_attributes.starting_numbers || []
      let currentOptionIndex = startingNumbers.findIndex(option => option.product_id === this.productOption[this.optionId].product_id)

      currentOptionIndex >= 0
        ? startingNumbers[currentOptionIndex] = this.additionalOption
        : startingNumbers.push(this.additionalOption)

      const patched_extension_attributes = Object.assign({}, this.product.product_option.extension_attributes, { starting_numbers: startingNumbers })

      this.product.sku !== this.getCurrentProduct.sku
        ? Vue.set(this.$store.state.product.related, 'upsell', [Object.assign({}, this.product, { product_option: { extension_attributes: patched_extension_attributes } })])
        : this.$store.commit('product/product/SET_CURRENT', Object.assign({}, this.product, { product_option: { extension_attributes: patched_extension_attributes } }))
    }
  }
}
</script>

<style lang="scss" scoped>
.prenumerate {
  .bundleOption {
    transition: all 0.2s ease;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
      filter: grayscale(1);
    }
  }
}
.add-to-cart {
  transition: all 0.2s ease;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(1);
  }
}
</style>
